import * as React from 'react';
import { Badge } from '@emorg-prd/standard-react';

interface RiskBadgeProps {
    risk?: string;
    fullWidth?: boolean;
}

export default class RiskBadge extends React.Component<RiskBadgeProps> {
    type?:
        | 'em-c-badge--positive'
        | 'em-c-badge--caution'
        | 'em-c-badge--negative';

    constructor(props: RiskBadgeProps) {
        super(props);

        switch (props.risk?.toLowerCase()) {
            case 'low':
                this.type = 'em-c-badge--positive';
                break;

            case 'medium':
                this.type = undefined;
                break;

            case 'high':
                this.type = 'em-c-badge--caution';
                break;

            case 'critical':
                this.type = 'em-c-badge--negative';
                break;

            default:
                this.type = undefined;
                break;
        }
    }

    render() {
        return (
            <Badge
                optionalClass={`em-u-max-width-10 ${
                    (this.props.fullWidth && 'em-u-width-100') || ''
                }`}
                type={this.type}
                text={this.props.risk ?? 'Unknown'}
            />
        );
    }
}